import { ILightingDefect } from "../data/lightingForm/types";

export const initialValuesLighting: ILightingDefect = {
  incidentStatusId: null,
  objectTypeId: null,
  classifierTypeId: null,
  objectId: null,
  objectShortName: "",
  mediaCoverage: false,
  mediaComment: null,
  statusComment: "",
  districtId: null,
  addressText: null,
  dateTimeDisable: null,
  dateTimeEnable: null,
  dateTimePlanned: null,
  timeDisable: "",
  gasPlannedTime: "",
  timeEnable: "",
  standartTime: null,
  dateTimeWorkStarted: null,
  disconnectedSubscribers: null,
  responsible: null,
  responsiblePhone: null,
  lightingWorkStartedTime: null,
  comment: "",
  eventTypeId: null,
  gridTypeId: 4,
  placeOfWorkText: "",
  lightingProblemTypeId: null,
  producedWorkId: null,
  workTypeId: null,
  clarifiedWorkType: "",
  externalSystemId: 1,
  externalId: null,
  addressNote: "",
  files: [],
  organizationId: null,
};
